import { render, staticRenderFns } from "./fileUploader.vue?vue&type=template&id=31253264&scoped=true"
import script from "./fileUploader.vue?vue&type=script&lang=js"
export * from "./fileUploader.vue?vue&type=script&lang=js"
import style0 from "./fileUploader.vue?vue&type=style&index=0&id=31253264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31253264",
  null
  
)

export default component.exports